import React, { useEffect, useState } from 'react';
import './index.css';
import { useParams } from 'react-router-dom';


function Inicio() {
    const app = useParams().param;
    const [email, setEmail] = useState<string>("");
    useEffect(()=>{console.log(app)})
    return (
        <div className="App">
        <header className="App-header">
            <p>Central de exclusão de contas</p>
            <h1>{app}</h1>
            <p>Deseja excluir a sua conta para o {app}?</p>
            <p>Digite o e-mail da conta a excluir:</p>
            <input value={email} onChange={(event)=>setEmail(event.target.value)} placeholder='usuario@email.com'></input>
            <button onClick={()=>{
                if(email===""){
                    alert("Digite seu Email!");
                }else if(email?.includes("@") === false || email?.includes(".") === false){
                    alert("digite um e-mail válido");
                }else{
                    window.open('https://wa.me/8232155104?text=Olá, gostaria de solicitar a exclusão de minha conta e dados para o '+app+', meu usuário é "'+email+'".');
                }
            }}>SOLICITAR EXCLUSÃO</button>
            
            <img src={require("../assets/images/logo.png")}/>
        </header>
        </div>
    );
}

export default Inicio;
